//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CompilationTextAndBtns from "~/components/compilations/CompilationTextAndBtns"
import CompilationQr from "~/components/compilations/CompilationQr"
export default {
  inject: ['$isMobile'],
  components: {
    CompilationTextAndBtns,
    CompilationQr
  },
  props: {
    compilation: {
      type: Object,
      required: true
    }
  },
  computed: {
    isMobile() {
      return this.$isMobile()
    },
    isQrTemp () {
      return Boolean(this.compilation?.topTemplate?.xmlId && this.compilation.topTemplate.xmlId == 3)
    },
    isTextTemp () {
      return Boolean(this.compilation?.topTemplate?.xmlId && this.compilation.topTemplate.xmlId == 1)
    },
    isBtnTemp () {
      return Boolean(this.compilation?.topTemplate?.xmlId && this.compilation.topTemplate.xmlId == 2)
    },
    showMobText () {
      return Boolean(this.isMobile && this.compilation && this.compilation.textMob)
    }
  }
}
